import React from 'react';
import { useSelector, useDispatch } from "react-redux";
import { Button } from "react-bootstrap";
import _ from "lodash";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { copyToClipboard, MESSAGES, addEventNameToEndpoint } from "../utils/common";
import { ShareType } from "../constants/Types";
import ShareItemForm from "./dashboard/ShareItemForm";
import './ButtonShareWithRecipient.scss';

const ReactSwal = withReactContent(Swal);

/**
 * Button to share with recipients and track shares
 * props: 
 *  shortInfo
 *  itemId
 *  itemShortUrl
 *  variant
 */
const ButtonShareWithRecipient = props => {
  const [shortInfo, setShortInfo] = React.useState(null);
  const shareButtonRef = React.createRef();
  const dispatch = useDispatch();

  const Analytics = useSelector(({ auth }) => auth.Analytics);
  const orgShortInfo = useSelector(({ item }) => item.shortInfo);
  const ctaList = useSelector(({ settings }) => (settings.ctas || []).filter(ct => !ct.deletedAt) );

  React.useEffect(() => {
    const thisItemId = _.get(props, "itemId", null);

    if (orgShortInfo && orgShortInfo.id.includes(thisItemId)) {
      setShortInfo(orgShortInfo);
    }
  }, [orgShortInfo]);

  React.useEffect(() => {
    // console.log({function: "compDidUpdate", props: props});
    // notify on new recipient share
    const didAlert = _.get(shortInfo, "didAlert", true);
    if (!didAlert) {
      copyAndNotifyRecipientShare();

      if (props.onChangeEvent) {
        props.onChangeEvent();
      }
    }
  }, [shortInfo]);

  const copyAndNotifyRecipientShare = () => {
    if (shortInfo && shortInfo.shareId) {
      const { shortUrl, shareId, id, tenantId, itemType, itemId, hashedPassword } = shortInfo;
      
      const attributes = { tenantId, shortUrl: shortUrl.replace("https://", "") };
      if (itemType === ShareType.Item || !itemType) {
        attributes.itemId = itemId;
      }
      if (itemType === ShareType.Site) {
        attributes.siteId = itemId;
      }
      
      if (!hashedPassword) {
        const trackingUrl = `${shortUrl}?sid=${shareId}`;
        copyToClipboard(trackingUrl, MESSAGES.URL_RECIPIENT_COPY);
      } else {
        const urlParts = shortUrl.split('/')
        const lessUrl = [
          ...urlParts.slice(0, urlParts.length - 1),
          'sites',
          'p',
          shareId
        ]
        const trackingUrl = lessUrl.join('/');
        copyToClipboard(trackingUrl, MESSAGES.URL_RECIPIENT_COPY);
      }
      shortInfo.didAlert = true;

      // analytics
      addEventNameToEndpoint(Analytics, 'user-shorturl-share');
      Analytics.record({name: 'user-shorturl-share', attributes});
    }
  }

  const onOpenShareModal = () => {
    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <ShareItemForm
          onClose={ReactSwal.clickConfirm}
          itemId={props.itemId}
          ctaList={ctaList}
          dispatch={dispatch}
          enableCTA={false} //{process.env.REACT_APP_FLAG_CTA === "true"}
          itemType={props.itemType}
          itemTitle={props.itemTitle}
          shortUrl={_.get(props, 'itemShortUrl', '')}
          changeNotificationPermission={props.changeNotificationPermission}
        />
      )
    })
    .then(result => {
      if (result.value) {
        
      }
    });
  }

  const { itemId, itemShortUrl } = props;

  return (
    <Button
      variant={_.get(props, "variant", "outline-danger")}
      className="btn btn-outline-danger"
      size="sm"
      data-cc-analytics-on="click"
      id="btnItemUrlShare"
      // we capture the share event as a copy here
      // but as a share in the method
      data-cc-analytics-name="user-shorturl-copy"
      data-cc-analytics-attrs={`${props.itemType === ShareType.Site ? "siteId" : "itemId"}:${itemId},shortUrl:${(itemShortUrl || '').replace("https://", "")}`}
      onClick={e => {
        e.preventDefault();
        onOpenShareModal();
        return true;
      }}
    >
      SHARE
    </Button>
  );
}

export default ButtonShareWithRecipient;
